export default "__VITE_ASSET__ZY0nLhYA__"